import React from "react";
import CloseIcon from '@mui/icons-material/Close';
import KeyboardArrowLeftOutlinedIcon from '@mui/icons-material/KeyboardArrowLeftOutlined';
import { Dialog, DialogTitle, Divider, IconButton } from "@mui/material";
import { Box, Stack } from "@mui/system";

export default function GeneralModal({ title, children, open, handleOpen, responsive, hasDivider, handleBackButton, maxWidth, noCloseButton, fullHeight }) {

    const responsiveStyle = {
        width: "90% !important",
        height: "90% !important",
        maxWidth: "unset !important",
        margin: "0 !important",
    }

    const handleClose = () => {
        handleOpen(false);
    }

    return (
        <Dialog 
            open={open}
            PaperProps={{
                sx: responsive ? responsiveStyle : {p: 1}
            }}
            scroll="body"
            onClose={handleClose}
            fullWidth={maxWidth ? true : responsive}
            maxWidth={!responsive && (maxWidth ? maxWidth : "sm" )}
        >
            <Stack justifyContent="space-between" alignItems="center" direction="row" sx={{ml: 2}}>
                {title && <DialogTitle sx={{fontWeight: "bold"}}>{title}</DialogTitle>}
                <Box>
                    {
                        handleBackButton ?
                        <IconButton onClick={() => handleBackButton(false)}>
                            <KeyboardArrowLeftOutlinedIcon />
                        </IconButton>
                        :
                        !noCloseButton ?
                            <IconButton onClick={() => {handleOpen(false)}}>
                                <CloseIcon />
                            </IconButton>
                        : null
                    }
                    
                </Box>
            </Stack>
            {hasDivider && <Divider variant="middle" sx={{mb: 2}} />}
            <Box sx={{p: 2, height: fullHeight ? "calc(100% - 48px) !important" : "auto"}}>
                {children}
            </Box>
        </Dialog>
    )
}